import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { buttonTypes, PartyState, ActivityTabs, BookingBehavior, AvailabilityCriteria, ComponentTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { ActivitySlotRequestDTO, SessionBookingDTO, ClassType, ActivityRatePlanRequest, AvailabilityType, LockSessionRequestDTO, BookingActivity } from 'src/app/shared/Models/SessionBookingDTO';
import { SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { DayOfWeek, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';

@Component({
  selector: 'app-private-activity-booking',
  templateUrl: './private-activity-booking.component.html',
  styleUrls: ['./private-activity-booking.component.scss']
})
export class PrivateActivityBookingComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy {
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  cancelButton: ButtonValue;
  CheckAvailabilityBtn: ButtonValue;
  reservationConfig: FieldConfig[];
  locationConfig: FieldConfig[];
  customizeSizeConfig: FieldConfig[];
  from_dateConfig: FieldConfig[];
  to_dateConfig: FieldConfig[];
  age_config: FieldConfig[];
  search_config: FieldConfig[];
  buttonType = buttonTypes;
  coverTypeConfig: FieldConfig[];
  bookingTypeConfig: FieldConfig[];
  bookingType_config: FieldConfig[];
  coverTypes = [];
  bookingTypes = [];
  classDetail: any;
  @ViewChild('reservationConfigForm', { static: true }) reservationConfigForm: DynamicFormComponent;
  @ViewChild('dateConfigForm', { static: true }) dateConfigForm: DynamicFormComponent;
  @ViewChild('coverTypeForm', { static: true }) coverTypeForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  Subscriptions: Subscription = new Subscription();
  availableActivities: any;
  tempAvailableActivities: any;
  SelectedIndex: number;
  SelectedActivityData: any;
  InstructorList: any[];
  LocationList: any[];
  minSizeAllowed: number = 1;
  bookingSizeArray: any = [];
  SessionSlotsAvailableDates: any = null;
  showSessionorSlots: boolean = false;
  isSessionClass: any;
  selectedIndex: number = 0;
  public sessionsUnavailable: any[];
  isMultiSlotSelection: any;
  availableSessions: any[];
  classLessonList: any[];
  selectedClassSchedule: any = [];
  dayOfWeek = DayOfWeek;
  EditData: any;
  lockResponse: any;
  ratePlan: any;
  checkedItem = false;
  operatingCurrency: any;
  SelectedTimeSlots: any = [];
  Operation = operationType;
  validCoverTypes: boolean = true;
  validBookingTypes: boolean = true;
  validGroupSize: boolean = true;
  formRepeatCount = 0;
  widgetData: any;
  availableSlots = [];
  displaySlots: boolean;
  constructor(private ts: TranslateService, public activityService: GuestService, public dialog: MatDialog, private datePipe: DatePipe) {
    super(dialog);
    this.Subscriptions.add(this.activityService.editPartyData$.subscribe(data => {
      if (data) {
        this.EditData = data;
        if (this.EditData && (this.EditData.State === PartyState.Seated || this.EditData.State === PartyState.Cancelled || this.EditData.State === PartyState.Left)) {
          this.activityService.TabChange$.next(ActivityTabs.ConfirmationSummary);
        }
        if (this.EditData && this.EditData.Contact?.TrackMembershipNumber) {
          this.CheckMemberShip(this.EditData.Contact.TrackMembershipNumber, this.EditData);
        }
      }
    }))
    this.Subscriptions.add(this.activityService.restaurantWidgetSettings$.subscribe(value => {
      this.widgetData = value;
      this.isMultiSlotSelection = value.EnableMultiSlotSelection;
      this.operatingCurrency = value.OperationCurrency;
    }));

    this.Subscriptions.add(this.activityService.TabChange$.subscribe(data => {
      if (data === ActivityTabs.ActivitySelection && this.EditData && this.EditData.ReservedFor &&
        this.activityService.bookingSection$.value === BookingActivity.PrivateLesson) {
        if (this.EditData && this.EditData.Contact?.TrackMembershipNumber) {
          this.CheckMemberShip(this.EditData.Contact.TrackMembershipNumber, this.EditData);
          setTimeout(() => {
            this.getavailableSlots();
          }, 300);
        } else {
          this.getavailableSlots();
        }
      }
    }));
    this.Subscriptions.add(this.activityService.SelectedActivity$.subscribe(data => {
      if (data) {
        if (this.activityService.operation === operationType.create) {
          this.resetValue();
        }
        setTimeout(() => {
          this.classDetail = data;
          if (this.classDetail) {
            this.activityService.selectedSpecialMeal = this.classDetail;
            this.SelectedActivityData = this.classDetail;
            this.createReservationConfig();
            this.createActionButtons();
            this.selectedClassActivity(this.SelectedActivityData);
          }
        }, 100);
      }
    }));
    this.Subscriptions.add(this.activityService.bookingSection$.subscribe(data => {
      if (this.components && this.activityService.operation === operationType.create && data === BookingActivity.PrivateLesson) {
        this.resetValue();
      }
    }));
    this.Subscriptions.add(this.activityService.BookNew$.subscribe(data => {
      if (data) {
        if (this.components) {
          this.resetValue();
        }
        this.activityService.BookNew$.next(false);
      }
    }));
  }


  ngOnInit(): void {

    if (this.activityService.SelectedActivity$.value) {
      this.SelectedActivityData = this.activityService.SelectedActivity$.value;
    }
    this.createReservationConfig();
    this.createActionButtons();
  }

  createReservationConfig() {
    this.reservationConfig = [
      {
        type: 'select',
        name: 'Instructor',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        value: this.EditData ? this.EditData.StaffIds && this.EditData.StaffIds.length > 0 ? this.EditData.StaffIds[0] : '' : '',
        label: this.ts.instant('SelectaInstructor'),
        class: "activity-instructor",
        validation: [Validators.required],
      }

    ];
    this.locationConfig = [
      {
        type: 'select',
        name: 'Location',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        value: this.EditData ? this.EditData.Location && this.EditData.Location.length > 0 ? this.EditData.Location[0] : '' : '',
        label: this.ts.instant('SelectaLocation'),
        class: "activity-instructor",
        validation: [Validators.required],
      }];

    this.from_dateConfig = [
      {
        type: 'date',
        name: 'FromDate',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('FromDate'),
        minDate: new Date(),
        value: this.EditData ? this.EditData.ReservedFor ? this.EditData.ReservedFor : new Date() : new Date(),
        maxDate: '',
        class: "selector-date",
        validation: [Validators.required],
      }
    ];
    this.customizeSizeConfig = [
      {
        type: 'autocomplete',
        name: 'BookingSize',
        placeholder: 'select',
        options: this.calculatePartySize(),
        appearance: true,
        partySize: true,
        isFormArray: false,
        class: "activity-instructor",
        showErrorText: true,
        charLength: this.SelectedActivityData?.MaxPartySize.toString().length,
        validation: [Validators.required, Validators.min(this.SelectedActivityData?.MinPartySize), Validators.max(this.SelectedActivityData?.MaxPartySize)],
        value: this.EditData ? this.EditData.Size ? this.EditData.Size : '' : ''
      },
    ]

    this.search_config = [
      {
        type: 'input',
        label: "",
        placeholder: this.ts.instant('SearchbyActivityName'),
        name: 'SearchbyActivityName',
        inputType: 'text',
        class: 'guest-details__first-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        value: ''
      },
    ];

  }
  resetValue() {
    if (this.components) {
      var [Instructor, Location, FromDate, BookingSize, bookingtypes, covertype] = this.components;
      Instructor.form.reset("Instructor");
      Location.form.reset("Location");
      FromDate.form.reset("FromDate");
      BookingSize.form.reset("BookingSize");
      if (bookingtypes) {
        bookingtypes.form.reset(this.getBookingTypeName());
      }
      if (covertype) {
        covertype.form.reset(this.getCoverTypeName());
      }
    }
  }
  getBookingTypeName(): FieldConfig[] {
    return this.bookingTypes.map(bookingType => {
      return bookingType.Name;
    })
  }
  getCoverTypeName(): FieldConfig[] {
    return this.coverTypes.map(coverType => {
      return coverType.Name;
    })
  }
  isFormValid() {
    var isValid = true;
    this.components.forEach(componet => {
      if (componet.form && !componet.form.valid && componet.form.status !== "DISABLED") {
        isValid = false;
      }
    })
    return isValid;
  }

  getFormValue(formObj, fieldName) {
    return formObj && formObj.form.get(fieldName)?.value;
  }

  getCoverTypeValues(covers) {
    return this.coverTypes.map(coverType => {
      return { covers: covers[coverType.Name], Covers: covers[coverType.Name], CoverTypeId: coverType.Id, Name: coverType.Name }
    })
  }

  isCoverTypeMatchBookingSize() {

    var coverTypeTotal = 0;

    if (!this.coverTypeConfig || !this.coverTypeConfig.length) {
      return true;
    }
    else {
      if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
        var [, , , bookingSize, covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
      else {
        var [, , , bookingSize, , covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
    }

    if (this.getFormValue(bookingSize, "BookingSize") === '') {
      return false;
    } else {
      return +this.getFormValue(bookingSize, "BookingSize") == coverTypeTotal;
    }
  }
  getBookingTypeValues(bookingTypes) {
    return this.bookingTypes.map(bookingType => {
      return { BookingTypes: bookingTypes[bookingType.Name], BookingTypeId: bookingType.Id, Name: bookingType.Name }
    })
  }
  isBookingTypeMatchBookingSize() {
    if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
      return true;
    }
    var [, , , bookingSize, bookingTypes,] = this.components;


    var bookingTypeTotal = 0;
    bookingTypes.controls.forEach((control, index) => {
      bookingTypeTotal += +bookingTypes.form.controls[this.bookingTypes[index].Name].value;
    });
    return +this.getFormValue(bookingSize, "BookingSize") === bookingTypeTotal;
  }

  updateFormValidity() {
    return this.isFormValid() && this.isValidBookingSizeSelected() && this.isCoverTypeMatchBookingSize() && this.isBookingTypeMatchBookingSize() && this.istimeSlotsSelected() && this.isValidDuration();
  }

  istimeSlotsSelected() {
    return Object.values(this.activityService.selectedOpenBookingSlots).findIndex(slot => slot) !== -1;
  }

  isValidBookingSizeSelected() {
    var [activity, , , bookingSize] = this.components;
    let selectedSize = +this.getFormValue(bookingSize, "BookingSize")
    if (this.SelectedActivityData) {

      this.validGroupSize = true;
      this.validGroupSize = selectedSize >= this.SelectedActivityData.MinPartySize && selectedSize <= this.SelectedActivityData.MaxPartySize;

      const minsize = this.SelectedActivityData.MinPartySize;
      const maxsize = this.SelectedActivityData.MaxPartySize;
      return this.validGroupSize;
    }
    return false;
  }

  getFormComponent(...args) {
    return args.map(arg => this.components.find(form => form && form.form ? form.form?.value[arg] : form?.value[arg]))
  }

  CheckMemberShip(membershipId, editContactData) {
    this.Subscriptions.add(this.activityService.getContactFromEngagebyCardno(membershipId).subscribe(response => {
      if (response.Payload) {
        const memberShipdetail = response.Payload;
        let editPartyData = {
          Id: this.EditData && this.EditData.Id !== null ? this.EditData.Id : null,
          Contact: {},
        };
        const memberType = this.widgetData.AllocationMappings.find(allocation => allocation.AllocationTypeName.trim().toLowerCase() === memberShipdetail.MembershipType.trim().toLowerCase());
        const guestObject = {
          FirstName: memberShipdetail.FName,
          LastName: memberShipdetail.LName,
          EmailAddress: memberShipdetail.Email,
          PhoneNumber: memberShipdetail.PhoneNumber,
          CountryId: this.activityService.getCountryId(memberShipdetail.PhoneCode),
          PIILastUsedDate: null,
          EmailAddress2: memberShipdetail.EmailList ? memberShipdetail.EmailList[1]?.EmailId : null,
          PhoneNumber2: memberShipdetail.PhoneList ? memberShipdetail.PhoneList[1]?.PhoneNumber : memberShipdetail.PhoneNumber,
          Birthday: memberShipdetail.Dob,
          ContactCustomFields: [],
          Notes: [],
          VisitStats: [],
          MarketingOptedIn: null,
          memberShipId: memberShipdetail.CardNo,
          MembershipType: memberShipdetail.MembershipType,
          MemberActive: memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        if (editContactData) {
          editContactData.memberShipId = memberShipdetail.CardNo,
            editContactData.MembershipType = memberType,
            editContactData.MemberActive = memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        this.activityService.selectedGuest = editContactData ? editContactData : guestObject;
        this.activityService.selectedGuest = guestObject;
        this.activityService.selectedGuest.TrackMembershipNumber = memberShipdetail.CardNo; // to bind it in the guest form
        this.activityService.membershipId = guestObject.MemberActive ? this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(x => x.AllocationTypeName.trim().toLowerCase() == response.Payload.MembershipType.trim().toLowerCase())?.AllocationTypeId : null;
      }
    }))
  }


  getavailableSlots() {
    let specialMealId = this.activityService.selectedSpecialMeal ? this.activityService.selectedSpecialMeal.SpecialMealId : null;
    var [Instructor, Location, fromdate] = this.components;
    var date = moment(fromdate.form.get("FromDate").value).format("YYYY-MM-DD");
    if (Location.form.get("Location").value && fromdate.form.get("FromDate").value && Instructor.form.get("Instructor").value) {
      this.activityService.selectedOpenBookingSlots = {};

      this.activityService.slots_holder = [];
      this.displaySlots = false;

      this.Subscriptions.add(this.activityService.getSlotsForTable([Location.form.get("Location").value], [Instructor.form.get("Instructor").value], date, specialMealId).subscribe(response => {
        this.setSlots(response);
        setTimeout(() => {
          this.activityService.slotAvailabilitySubject$.next(response);
          this.activityService.partySlots$.next(true);
        }, 100);

      }));
    }
  }

  setSlots(response) {
    let SlotIds = 0;
    this.availableSlots = [];
    this.activityService.slots_holder = [];
    this.activityService.SlotIds = 0;
    this.activityService.selectedOpenBookingSlots = {}
    response.Payload.forEach((element, index) => {
      if (index === 0) {
        element.OpenHours.forEach(openHour => {
          var tableId = openHour.SlotsByTableId[0].TableId;
          openHour.SlotsByTableId[0].Slots.sort((a, b) => Utilities.parseDateString(a.DateTime).getTime() - Utilities.parseDateString(b.DateTime).getTime());
          openHour.SlotsByTableId[0].Slots.forEach(slot => {
            if (!slot.PartyId || (this.EditData && slot.PartyId && this.EditData.Id == slot.PartyId)) {
              if (slot.AllocationTypeId && this.widgetData.AllocationMappings && this.widgetData.AllocationMappings.length) {
                var { R, G, B, A } = this.widgetData.AllocationMappings.filter(type => type.AllocationTypeId === slot.AllocationTypeId)[0].Color;
                slot['color'] = `rgba(${R}, ${G}, ${B}, ${A})`;
              }
              SlotIds += 1;
              slot.Id = slot.Id == 0 ? SlotIds : slot.Id;
              if (this.isNotPastTimeSlot(slot.DateTime)) {
                this.activityService.slots_holder.push(slot);
              }
              let selectedSlot = null;
              if (this.EditData?.Slots) {
                selectedSlot = this.EditData.Slots.find(x => x.Time === slot.DateTime);
              }
              if (this.EditData && slot.PartyId && this.EditData.TableIds[0] == tableId && this.EditData.Id == slot.PartyId) {
                this.activityService.selectedOpenBookingSlots[slot.Id] = !this.activityService.selectedOpenBookingSlots[slot.Id];
                if (!this.EditData.Duration) {
                  this.EditData.Duration = Utilities.diffBetweenDatesInMinutes(this.EditData.DepartureTime, this.EditData.SeatingTime);
                }
                if (this.EditData.Duration > this.widgetData.TimeSlotUnitInMinutes) {

                  var duration = this.EditData.Duration - this.widgetData.TimeSlotUnitInMinutes;
                  for (var i = 1; i <= duration / this.widgetData.TimeSlotUnitInMinutes; i++) {
                    var newSlot = this.activityService.generateSlot(Utilities.Date(slot.DateTime).add(i * this.widgetData.TimeSlotUnitInMinutes, 'minutes'));

                    newSlot.PartyId = slot.PartyId;
                    if (newSlot.Id == 0) {
                      SlotIds += 1;
                      newSlot.Id = SlotIds;
                    }
                    this.activityService.slots_holder.push(newSlot);
                    this.activityService.selectedOpenBookingSlots[newSlot.Id] = true;
                  }
                  // this.setBookingData();
                }
                this.checkFormValidity();
              } else if (selectedSlot) {
                this.activityService.selectedOpenBookingSlots[slot.Id] = !this.activityService.selectedOpenBookingSlots[slot.Id];
                if (selectedSlot.Duration > this.widgetData.TimeSlotUnitInMinutes) {
                  var duration = selectedSlot - this.widgetData.TimeSlotUnitInMinutes;
                  for (var i = 1; i <= duration / this.widgetData.TimeSlotUnitInMinutes; i++) {
                    var newSlot = this.activityService.generateSlot(Utilities.Date(slot.DateTime).add(i * this.widgetData.TimeSlotUnitInMinutes, 'minutes'));
                    newSlot.PartyId = slot.PartyId;
                    if (newSlot.Id == 0) {
                      SlotIds += 1;
                      newSlot.Id = SlotIds;
                    }
                    this.activityService.slots_holder.push(newSlot);
                    this.activityService.selectedOpenBookingSlots[newSlot.Id] = true;
                  }
                }
                this.checkFormValidity();
              }
            }
          });
          var openhrSlots = openHour.SlotsByTableId[0].Slots;
          openhrSlots.forEach(slot => {
            if (this.EditData?.Slots) {
              let selectedSlot = null;
              if (this.EditData?.Slots) {
                selectedSlot = this.EditData.Slots.find(x => x.Time === slot.DateTime);
              }
              if (selectedSlot && selectedSlot.DurationInMinutes > this.widgetData.TimeSlotUnitInMinutes) {
                var duration = selectedSlot.DurationInMinutes - this.widgetData.TimeSlotUnitInMinutes;
                for (var i = 1; i <= duration / this.widgetData.TimeSlotUnitInMinutes; i++) {
                  var existingslot = openhrSlots.find(x => Utilities.Date(x.DateTime).isSame(Utilities.Date(slot.DateTime).add(i * this.widgetData.TimeSlotUnitInMinutes, 'minutes')));
                  this.activityService.selectedOpenBookingSlots[existingslot.Id] = true;
                }
              }
            }

          });
          this.checkFormValidity();
        });
      }
    });

  }

  setBookingData() {
    var [instructor, fromDate, bookingSize, location] = this.getFormComponent("Instructor", "FromDate", "BookingSize", "Location");
    var covers = null;
    var bookingTypes = null;
    if (this.bookingTypeConfig && this.bookingTypeConfig.length) {
      bookingTypes = this.components['_results'][4].form.value;
      if (this.coverTypeConfig && this.coverTypeConfig.length) {
        covers = this.components['_results'][5].form.value;
      }
    }
    else if (this.coverTypeConfig && this.coverTypeConfig.length) {
      covers = this.components['_results'][4].form.value;
    }
    var instructors = instructor.form.get("Instructor").value == -1 ? this.InstructorList.filter(y => y.id !== -1).map(x => {
      return x.id;
    }) : [instructor.form.get("Instructor").value]

    var locations = location.form.get("Location").value == -1 ? this.LocationList.filter(y => y.id !== -1).map(x => {
      return x.id;
    }) : [location.form.get("Location").value]

    this.activityService.SessionBookingObj = new SessionBookingDTO(
      null,
      this.SelectedActivityData.SpecialMealId,
      this.SelectedActivityData.ClassType,
      this.getFormValue(fromDate, "FromDate"),
      this.getFormValue(fromDate, "FromDate"),
      locations,
      this.SelectedActivityData.LocationName,
      instructors,
      this.getFormValue(bookingSize, "BookingSize"),
      '',
      this.getCoverTypeValues(covers),
      this.getBookingTypeValues(bookingTypes),
      this.getSlotsObj(),
      null
    );
    if (!this.isSessionClass) {
      this.activityService.SelectedClassSchedule$.next(this.selectedClassSchedule);
    }
    // this.activityService.SessionBookingObj.AvailabilityCriteria = this.getAvailabilityCriteria(location, instructors);
    this.createSaveRequestObject();
  }


  getSlotsObj() {
    let { selectedOpenBookingSlots, slots_holder } = this.activityService
    let resSlots = [];
    let slots = Object.entries(selectedOpenBookingSlots)
      .filter(arr => arr[1]);
    for (let slotI = 0; slotI < slots.length; slotI++) {
      let itm = slots[slotI];
      let currentSlotIndex = slots_holder.findIndex(slot_holder => slot_holder.Id == itm[0]);
      if (currentSlotIndex >= 0) {
        var slot = slots_holder[currentSlotIndex];
        // if (slot.PartyId && slot.PartyId && this.EditData.ReservedFor != slot.DateTime) {
        //   continue;
        // }
        var resSlot = {
          LocalTime: slot.DateTime,
          Duration: this.widgetData.TimeSlotUnitInMinutes,
          EndTime: this.calculateEndTime(slots_holder[currentSlotIndex].DateTime, this.widgetData.TimeSlotUnitInMinutes),
          PartyId: (slot.PartyId && this.activityService.editPartyData$.value.Id) ? slot.PartyId : null,
          LockId: (this.lockResponse) ? this.lockResponse[slot.DateTime]?.SlotLockIdDTO?.Id : null,
        }

        for (let i = (currentSlotIndex + 1); slots_holder[i]; i++) {
          let slotDateTime = new Date(slots_holder[i].DateTime);
          let defaultDateTime = new Date(slots_holder[currentSlotIndex].DateTime);
          let mins: any = (slotDateTime.getTime() - defaultDateTime.getTime()) / (60 * 1000);
          if (slots.find(slot => slot[1] && +slot[0] == slots_holder[i].Id && mins <= resSlot.Duration)) {
            resSlot.Duration += this.widgetData.TimeSlotUnitInMinutes;
            slotI += 1;
          } else {
            break;
          }
        }
        resSlot.EndTime = this.calculateEndTime(resSlot.LocalTime, resSlot.Duration)
        resSlots.push(resSlot);
      }
    }

    return resSlots;
  }

  ngAfterViewInit() {
    this.formChangeSubscribe();
    this.nextButton.disbaledproperity = !this.updateFormValidity();
    if (this.activityService.SelectedActivity$.value) {
      this.selectedClassActivity(this.SelectedActivityData);
    }
  }

  calculateEndTime(startTimeStr, duration) {
    var startTime = new Date(startTimeStr);
    var startMins = startTime.getMinutes();
    startTime.setMinutes(startMins + duration);
    return startTime;
  }

  createActionButtons() {
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('next'),
      customclass: 'guest-details__confirm-btn',
    };
    this.cancelButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('previous'),
      customclass: 'reservation-details__previous-btn',
      disbaledproperity: true
    };
    this.CheckAvailabilityBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('checkAvailability'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('previous'),
      customclass: 'reservation-details__previous-btn',
    };
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('next'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
  }
  selectedClassActivity(data) {
    const currentDate = new Date();
    console.log(data);
    this.SelectedActivityData = data;
    this.isSessionClass = this.SelectedActivityData.ClassType === ClassType.Session;
    const StaffList = data.StaffValues;
    this.minSizeAllowed = data.MinPartySize;
    this.from_dateConfig[0].maxDate = new Date(data.EndDate);
    this.from_dateConfig[0].minDate = new Date(data.StartDate) > currentDate ? new Date(data.StartDate) : currentDate;
    this.coverTypes = data.CoverTypePrices.map(type => {
      return {
        Id: type.Id,
        Name: type.CoverTypeName
      }
    });
    this.bookingTypes = data.BookingTypeActivitiesMappings.map(type => {
      return {
        Id: type.Id,
        Name: type.BookingTypeName
      }
    });

    this.customizeSizeConfig[0].validation = [Validators.required, Validators.min(this.SelectedActivityData?.MinPartySize), Validators.max(this.SelectedActivityData?.MaxPartySize)];

    let instructorList = this.InstructorList = this.getInstructor(StaffList);
    this.reservationConfig[0].options = this.InstructorList;
    let locationList = this.LocationList = this.getLocations(data.LocationId);
    this.locationConfig[0].options = this.LocationList;
    this.reservationConfig[0].value = this.EditData && this.EditData.StaffIds && this.EditData.StaffIds.length ? this.EditData.StaffIds[0] : instructorList?.length === 1 ? instructorList[0].id : -1;
    this.locationConfig[0].value = this.EditData && this.EditData.TableIds && this.EditData.TableIds.length ? this.EditData.TableIds[0] : locationList?.length === 1 ? locationList[0].id : -1;
    this.from_dateConfig[0].value = new Date();
    this.components.forEach(x =>
      x.form.updateValueAndValidity()
    );
    this.updateCoverConfig();
    this.showSessionorSlots = false;
    this.selectedClassSchedule = [];
    this.SessionSlotsAvailableDates = [];
    this.activityService.selectedOpenBookingSlots = {};
    if (this.activityService.operation === operationType.create) {
      this.from_dateConfig[0].value = new Date();
    }
    this.components.forEach((x) => {
      if (x.form.controls["FromDate"]) {
        x.form.controls["FromDate"].setValue((this.EditData && this.EditData.ReservedFor) ? this.EditData.ReservedFor : (new Date(data.StartDate) > currentDate ? new Date(data.StartDate) : currentDate));
        x.form.controls["FromDate"].setValidators([Validators.required, Validators.min(new Date(data.StartDate) > currentDate ? data.StartDate : currentDate), Validators.max(data.EndDate)]);
        x.form.updateValueAndValidity();
      }
      if (x.form.controls["BookingSize"]) {
        x.form.controls["BookingSize"].setValue(this.EditData ? this.EditData.Size ? this.EditData.Size : '' : '');
      }
    });

    // this.updateDateConfig();
    setTimeout(() => {
      this.coverTypeConfigChange();
      this.bookingTypeConfigChange();
    }, 500);
  }
  updateCoverConfig() {
    this.coverTypeConfig = this.getCoverTypeConfig();
    this.coverTypeConfig = this.coverTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })
    this.bookingTypeConfig = this.getBookingTypeConfig();
    this.bookingTypeConfig = this.bookingTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })
  }
  coverTypeConfigChange() {
    if (this.coverTypeConfig.length) {
      this.Subscriptions.add(
        this.components.last.form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validCoverTypes = this.isCoverTypeMatchBookingSize()
        }));
    }
  }
  bookingTypeConfigChange() {
    if (this.bookingTypeConfig.length) {
      this.Subscriptions.add(
        this.components.filter((item, index) => index === 4)[0].form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validBookingTypes = this.isBookingTypeMatchBookingSize()
        }));
    }
  }

  getInstructor(staffList) {
    let SelectedStaffList = [];
    staffList.forEach(staff => {
      const selectedStaff = this.activityService.InstructorList.filter(data => data.Id === staff.ServerId)[0];
      if (selectedStaff) {
        let serverval = "Unnamed";
        if (selectedStaff) {
          if (selectedStaff.Name) {
            serverval = selectedStaff.Name;
          }
          if (selectedStaff.LastName) {
            serverval = serverval + ' ' + selectedStaff.LastName;
          }
        }
        selectedStaff['value'] = serverval;

        SelectedStaffList.push(selectedStaff);
      }
    });
    SelectedStaffList = SelectedStaffList.map(data => {
      return {
        id: data.Id,
        value: data.value
      }
    })

    if (!(staffList.length > 1)) {
      this.reservationConfig = [
        {
          type: 'select',
          name: 'Instructor',
          placeholder: '',
          options: [],
          appearance: true,
          isFormArray: false,
          value: this.EditData ? this.EditData.StaffIds && this.EditData.StaffIds.length > 0 ? this.EditData.StaffIds[0] : SelectedStaffList[0].id : SelectedStaffList[0].id,
          label: this.ts.instant('SelectaInstructor'),
          class: "activity-instructor",
          validation: [Validators.required],
        }

      ];

    }
    return SelectedStaffList;
  }

  getLocations(LocationList) {
    let SelectedLocationList = [];
    LocationList.forEach(location => {
      const selectedLocation = this.activityService.LocationList.filter(data => data.Id === location.LocationId)[0];
      if (selectedLocation) {
        selectedLocation['value'] = selectedLocation.Name;
        SelectedLocationList.push(selectedLocation);
      }
    });
    SelectedLocationList = SelectedLocationList.map(data => {
      return {
        id: data.Id,
        value: data.value
      }
    })
    if (!(LocationList.length > 1)) {
      this.locationConfig = [
        {
          type: 'select',
          name: 'Location',
          placeholder: '',
          options: [],
          appearance: true,
          isFormArray: false,
          value: this.EditData ? this.EditData.Location && this.EditData.Location.length > 0 ? this.EditData.Location[0] : SelectedLocationList[0].id : SelectedLocationList[0].id,
          label: this.ts.instant('SelectaLocation'),
          class: "activity-instructor",
          validation: [Validators.required],
        }];
    }
    return SelectedLocationList;

  }


  setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize, ActivityId, InstructorIds) {

    var request = {
      Slots: Slots,
      ActivityId: ActivityId,
      GuestTypes,
      BookingTypes: BookingTypes,
      TableIds: Location,
      Size: +BookingSize,
      InstructorIds: InstructorIds,
      SessionSlot: null,
      TrackMembershipNumber: this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber,
      MemberType: this.activityService.selectedGuest?.MembershipType?.AllocationName,
      IsMemberActive: this.activityService.selectedGuest?.MemberActive,
      BookingBehavior: BookingBehavior.PrivateLesson
    } as ActivityRatePlanRequest;

    this.Subscriptions.add(this.activityService.GetSessionRatePlanCalculated(request).subscribe(response => {
      this.ratePlan = response.Payload;
      if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
        this.ratePlan.RatePlanCalculations = this.ratePlan.SlotList = this.ratePlan.RatePlanCalculations.map(slot => {
          slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
            coverVariant.CoverTypeName = this.coverTypes.find(coverType => coverType.Id == coverVariant.CoverTypeId).Name;
            return coverVariant;
          }).filter(coverVariant => coverVariant.Variant) : [];
          slot.bookingTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
            bookingTypeVariant.BookingTypeName = this.bookingTypes.find(bookingType => bookingType.Id == bookingTypeVariant.BookingTypeId).Name;
            return bookingTypeVariant;
          }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
          return slot;
        });
      } else {
        this.ratePlan.SlotList = Slots;
      }
      if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
        this.activityService.RatePlanList$.next(this.ratePlan);
      }
      this.activityService.TabChange$.next(ActivityTabs.ReservationDetails);
    }));
  }

  getCoverTypeConfig(): FieldConfig[] {
    return this.coverTypes.map(coverType => {
      return {
        type: 'select',
        label: coverType.Name,
        name: coverType.Name,
        value: (this.EditData && this.EditData.CoverTypeQuantities && this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id && ct.Covers > 0).length > 0) ? this.bookingSizeArray[this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id)[0].Covers - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }

  getBookingTypeConfig(): FieldConfig[] {
    return this.bookingTypes.map(bookingType => {
      return {
        type: 'select',
        label: bookingType.Name,
        name: bookingType.Name,
        value: (this.EditData && this.EditData.BookingTypeQuantities && this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id && bt.BookingTypes > 0).length > 0) ? this.bookingSizeArray[this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id)[0].BookingTypes - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }

  setCoverTypeValue(covertType) {
    this.EditData?.CoverTypes?.forEach(data => {
      if (data.CoverTypeId === covertType.Id) {
        return data.covers;
      }
    });
  }

  setBookingTypeValue(bookingType) {
    this.EditData?.BookingTypes?.forEach(data => {
      if (data.BookingTypeId === bookingType.Id) {
        return data.bookingTypes;
      }
    });
  }

  calculatePartySize() {
    this.bookingSizeArray = [];
    for (let i = 1; i <= this.SelectedActivityData?.MaxPartySize; i++) {
      this.bookingSizeArray.push({ id: i, value: i.toString() });
    }
    return this.bookingSizeArray;
  }

  formChangeSubscribe() {
    console.log(this.SelectedActivityData);
    this.components.forEach((x, index) => {
      this.Subscriptions.add(x.form?.valueChanges.pipe(debounceTime(100),
        distinctUntilChanged()).subscribe(value => {
          if (value.bookingType) {
            this.activityService.bookingType$.next(this.getFormComponent("bookingType")[0].form.controls.bookingType.value)
          }
          if (value.Location || value.Instructor || value.FromDate) {
            if (this.activityService.operation === operationType.create) {
              this.getavailableSlots();
              if (value.FromDate) {
                var date = new Date(value.FromDate);
                let dayOfWeek = moment.isMoment(date) ? date.day() : date.getDay();
                var activitySessions = this.SelectedActivityData.ActivitySessions.filter(session => session.Dayofweek == dayOfWeek);
                this.locationConfig[0].options = this.LocationList.filter(location => {
                  return !!(activitySessions.filter(session => !!(session.SessionLocationMappings.find(elm => elm.StandaloneTableId === location.id))).length)

                });
                this.reservationConfig[0].options = this.InstructorList.filter(server => {
                  return !!(activitySessions.filter(session => !!(session.SessionStaffMappings.find(elm => elm.ServerId === server.id))).length)

                });
              }
            }
            if (this.activityService.operation === operationType.edit) {
              if (this.activityService.reservationToken) {
                this.formRepeatCount = this.formRepeatCount + 1;
                if (this.formRepeatCount > 4) {
                  this.getavailableSlots();
                }
              }
              else {
                this.getavailableSlots();
              }
            }
          }
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validCoverTypes = this.isCoverTypeMatchBookingSize();
          this.validBookingTypes = this.isBookingTypeMatchBookingSize();
        })
      )
    });
  }



  navClick(moveDirection) {
    if ((moveDirection === 1 && this.selectedIndex === this.SessionSlotsAvailableDates.length - 1)
      || (moveDirection === -1 && this.selectedIndex === 0)) {
      return;
    }
    this.selectedIndex = this.selectedIndex + moveDirection;
  }


  applyToOtherDates(selectedDateIndex, event) {

    var selectedSessionIndexes = this.SessionSlotsAvailableDates[selectedDateIndex].AvailableSessions.map((session, index) => session.checked ? index : -1).filter(sessionIndex => sessionIndex != -1);
    if (event.checked) {
      this.sessionsUnavailable = [];
      if (!selectedSessionIndexes || !selectedSessionIndexes.length) {
        this.activityService.setMessageState(this.ts.instant("selectSessionsToApplyForAllDates"), 0);
        return;
      }
      this.SessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.checked = false;
          return session;
        })
        selectedSessionIndexes.forEach(index => {
          if (selectedDate.AvailableSessions[index] && selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.OpenToAll && !selectedDate.AvailableSessions[index].disabled) {
            selectedDate.AvailableSessions[index].checked = true;
          } else {
            if (!this.sessionsUnavailable[index] || !this.sessionsUnavailable[index].dates) {
              this.sessionsUnavailable[index] = { session: this.ts.instant("Session") + " " + (index + 1) + " " + this.ts.instant("not available on") + " ", dates: "" }
            }
            this.sessionsUnavailable[index].dates += this.sessionsUnavailable[index].dates ? ", " + moment(selectedDate.AvailableDate).format("LL") : moment(selectedDate.AvailableDate).format("LL");
          }
        });
      });
      this.sessionsUnavailable = this.sessionsUnavailable.filter(item => item)
      if (!this.sessionsUnavailable || !this.sessionsUnavailable.length) {
        //this.toastrService.success(this.ts.instant("Applied"), "", { timeOut: 3000, closeButton: true });
      } else {
        let errorMessage = ''
        var errObj = {
          ErrorDetails: {
            Error: this.sessionsUnavailable.map(session => {
              errorMessage = errorMessage + session.session + session.dates + '. '
            })
          },
          ErrorType: true,
          dialogTitle: 'error'
        }
        this.activityService.setMessageState(errorMessage, 0);
      }
    } else {
      this.SessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.checked = false;
          return session;
        })
      });
      this.updateFormValidity();
    }
  }



  slotChangeListners(event) {
    if (this.SelectedActivityData && this.SelectedActivityData.ClassType == ClassType.Class && event.checked) {
      let groupIdList: any[] = Utilities.uniqueBy(this.availableSessions, "SessionGroupId", "DayOfWeek", "SessionId");
      this.selectedClassSchedule = [];
      groupIdList = groupIdList.filter(group => group.SessionGroupId == event.SessionGroupId);
      groupIdList.forEach(groupDetail => {
        if (!this.selectedClassSchedule[groupDetail.DayOfWeek]) {
          this.selectedClassSchedule[groupDetail.DayOfWeek] = [];
        }
        let selectedItem = this.availableSessions.find(session => session.SessionGroupId == groupDetail.SessionGroupId && session.DayOfWeek == groupDetail.DayOfWeek && session.SessionId == groupDetail.SessionId);
        this.selectedClassSchedule[groupDetail.DayOfWeek].push(selectedItem);
      });
      this.classLessonList.forEach(session => {
        if (session.SessionId != event.SessionId || session.SessionGroupId != event.SessionGroupId) {
          session.checked = false;
        }
      });
      const checkedItem = this.classLessonList.filter(x => x.checked);
      this.checkedItem = checkedItem.length ? true : false;
    } else if (!this.isMultiSlotSelection && event.checked) {
      let isChecked = false;
      this.SessionSlotsAvailableDates.forEach((element, index) => {
        element.AvailableSessions.forEach(session => {
          if (session.SessionId != event.SessionId) {
            session.checked = false;
          }
          if (session.checked) {
            isChecked = true;
          }
        });
      });
      this.checkedItem = isChecked;
    } else {
      if (this.classLessonList && this.classLessonList.length > 0) {
        const checkedItem = this.classLessonList.filter(x => x.checked);
        this.checkedItem = checkedItem.length ? true : false
      } else {
        let isChecked = false;
        this.SessionSlotsAvailableDates.forEach((element, index) => {
          element.AvailableSessions.forEach(session => {

            if (session.checked) {
              isChecked = true;
            }
          });
        });
        this.checkedItem = isChecked;
      }
    }
    this.nextButton.disbaledproperity = !this.updateFormValidity();
  }
  isSlotBooked(date, sessionId, editData): boolean {
    return editData.BookedSessions.findIndex(session => moment(session.BookedDate).diff(moment(date), 'days') == 0 && session.ActivitySessionId == sessionId && session.SessionState != PartyState.Cancelled) > -1;
  }


  getStateOfBookedSession(date, sessionId, editData): PartyState {
    return editData.BookedSessions.find(session => moment(session.BookedDate).diff(moment(date), 'days') == 0 && session.ActivitySessionId == sessionId).SessionState;
  }



  updateSlotBasedOnBookedSession(slot, date) {
    const editData = this.activityService.editPartyData$.value;
    slot.checked = editData && editData.BookedSessions && editData.BookedSessions.length > 0 ? this.isSlotBooked(date.AvailableDate, slot.SessionId, editData) : false;

    if (slot.checked && editData && editData.BookedSessions && editData.BookedSessions.length > 0 && this.getStateOfBookedSession(date.AvailableDate, slot.SessionId, editData) == PartyState.Seated) {
      slot.Availability.AvailabilityType = AvailabilityType.SelectionCriteriaNotMatched;
      slot.checked = false;
    }

  }

  gotoPreviousPage(event) {
    this.activityService.TabChange$.next(ActivityTabs.ActvityView);
    this.activityService.SaveBookingObj = {};
    this.activityService.selectedOpenBookingSlots = {};
    this.activityService.slots_holder = [];
    this.resetPaymentInfo();
    if (this.activityService.lockResult && this.activityService.lockResult.SlotLockIdDTO) {
      this.activityService.unlockSessionsUrl(this.activityService.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.activityService.lockResult = null;
        this.activityService.offTimer();
      });
    }
  }

  resetPaymentInfo() {
    this.activityService.ispaymentInvolvedInfo = null;
    this.activityService.reservationAttemptInfo = null;
  }



  gotoNextPage(event) {
    if (this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber && !this.activityService.selectedGuest?.MemberActive) {
      const popUpMessage = [{
        confirmationMessage: this.ts.instant('memberShipExpired'),
        dialogTitle: this.ts.instant('memberShipStatus'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', 'static', popUpMessage,
        popUpMessage[0].dialogTitle);
      const confirm = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '250px', false, 'No', 'ok',
        'ok', false)
      return;
    }
    this.setBookingData();
    this.lockTables();
  }

  selectedItem(data, index) {
    this.SelectedActivityData = this.availableActivities[index];
    this.selectedClassActivity(this.SelectedActivityData);
  }


  lockTables() {
    var { Slots, GuestTypes, BookingTypes, Location, BookingSize, ActivityId, StaffId } = this.activityService.SessionBookingObj;
    var slots = Slots.map(slot => {
      return {
        "LocalTime": slot.LocalTime,
        "PartySize": BookingSize,
        "SeatingAreaId": null,
        "SeatingTypeId": null,
        "IsCommunalTable": false,
        "FromWebsite": true,
        "DurationInMinutes": slot.Duration,
        "lockIdToIgnore": slot.LockId || null,
        "TableIds": Location
      }
    });
    if (slots.length) {
      this.Subscriptions.add(this.activityService.lockTables(slots).subscribe(response => {
        this.lockResponse = response.Payload;
        this.activityService.lockMultipleResult = {};
        let lockData: any = Object.values(this.lockResponse);
        let lockKeys: any = Object.keys(this.lockResponse);
        let slotAvailablity = true;
        let msg = '';
        lockKeys.forEach((data, index) => {
          if (!this.lockResponse[data].SlotLockIdDTO?.Id) {
            slotAvailablity = false;
            msg = msg + this.datePipe.transform(data, 'hh:mm a');
            if (index !== lockKeys.length) {
              msg = msg + ', '
            }
          } else {
            let obj = {} as SlotLockResultDTO
            obj[data] = this.lockResponse[data];
            this.activityService.lockMultipleResult[data] = this.lockResponse[data];
          }
        });
        if (!slotAvailablity) {
          this.activityService.setMessageState(this.ts.instant('SlotIsNotFound') + ' for ' + msg, 0);
        } else {
          this.activityService.lockMultipleIds = Object.values(this.activityService.lockMultipleResult).map((x: SlotLockResultDTO) => x?.SlotLockIdDTO?.Id)
          let timer = moment(lockData[0].ExpiresAt).diff(moment(lockData[0].LockedAt), "seconds");
          this.activityService.showTimer = true;
          this.activityService.runTimer(timer);
          if (this.activityService.operation == operationType.edit) {
            this.setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize, ActivityId, StaffId);
            this.activityService.additionalGuestPage = false;
          } else {
            this.createSaveRequestObject();
            this.activityService.TabChange$.next(ActivityTabs.ReservationDetails);
          }
        }
      }));
    }

  }




  setRatePlanData(data) {
    this.ratePlan = data;
    if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
      this.ratePlan.RatePlanCalculations = this.ratePlan.RatePlanCalculations.map(slot => {
        slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
          coverVariant.CoverTypeName = this.coverTypes.find(coverType => coverType.Id == coverVariant.CoverTypeId).Name;
          return coverVariant;
        }).filter(coverVariant => coverVariant.Variant) : [];
        slot.bookingTypevariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
          bookingTypeVariant.BookingTypeName = this.bookingTypes.find(bookingType => bookingType.Id == bookingTypeVariant.BookingTypeId).Name;
          return bookingTypeVariant;
        }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
        return slot;
      });
    }
    if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
      this.activityService.RatePlanList$.next(this.ratePlan);
    }
    this.activityService.SelectedClassSchedule$.next(this.selectedClassSchedule);
    this.createSaveRequestObject();
  }

  createSaveRequestObject() {
    var bookingData = this.activityService.SessionBookingObj;
    if (this.activityService.operation === operationType.create) {
      this.activityService.SaveBookingObj = {
        "Id": bookingData.ActivityId,
        "Size": bookingData.BookingSize,
        "RemindAboutVisit": false,
        "RemindAboutVisitEmail": false,
        "AgreedWithTermsOfUse": true,
        "Contact": {},
        "Slots": this.getRequestObjectSlots(),
        "PartyId": null,
        "SeatingAreaId": null,
        "SeatingTypeId": null,
        "Notes": [],
        "TableIds": bookingData.Location,
        "InstructorIds": bookingData.StaffId,
        "CoverTypes": bookingData.GuestTypes,
        "BookingTypes": bookingData.BookingTypes,
        "IsCommunalTable": false,
        "FromWebsite": true,
        "Language": 0,
        "ReservationAttemptId": null,
        "waiverFormTransactionId": null,
        "SecondaryContactsList": null,
        "BookingBehavior": BookingBehavior.PrivateLesson,
        "SpecialMealId": bookingData.ActivityId,
        "StaffId": bookingData.StaffId,
        "StaffIds": bookingData.StaffId,
        "StartDate": new Date(bookingData.FromDate).toDateString(),//(moment(bookingData.FromDate).format()).split("+")[0],
        "EndDate": new Date(bookingData.ToDate).toDateString(),// (moment(bookingData.FromDate).format()).split("+")[0],
        "OpenTimeSlots": bookingData.Slots,
        "RatePlanTimeSlots": this.getRatePlanSlots(bookingData.Slots),
        "SelectedActivity": this.SelectedActivityData
      }
    } else {
      this.activityService.SaveBookingObj.Id = bookingData.ActivityId;
      this.activityService.SaveBookingObj.Size = bookingData.BookingSize;
      this.activityService.SaveBookingObj.Slots = this.getRequestObjectSlots();
      this.activityService.SaveBookingObj.StartDate =new Date(bookingData.FromDate).toDateString();// (moment(bookingData.FromDate).format()).split("+")[0];
      this.activityService.SaveBookingObj.EndDate = new Date(bookingData.ToDate).toDateString();//(moment(bookingData.FromDate).format()).split("+")[0];
      this.activityService.SaveBookingObj.SpecialMealId = bookingData.ActivityId;
      this.activityService.SaveBookingObj.StaffId = bookingData.StaffId;
      this.activityService.SaveBookingObj.StaffIds = bookingData.StaffId;
      this.activityService.SaveBookingObj.BookingBehavior = bookingData.ClassType;
      this.activityService.SaveBookingObj.TableIds = bookingData.Location;
      this.activityService.SaveBookingObj.InstructorIds = bookingData.StaffId;
      this.activityService.SaveBookingObj.CoverTypes = bookingData.GuestTypes;
      this.activityService.SaveBookingObj.BookingTypes = bookingData.BookingTypes;
      this.activityService.SaveBookingObj.SelectedActivity = this.SelectedActivityData;
      this.activityService.SaveBookingObj.BookingBehavior = BookingBehavior.PrivateLesson;
      this.activityService.SaveBookingObj.FromWebsite = true;
    }
  }

  getRatePlanSlots(timeslots) {
    return timeslots.map((slot) => {
      return {
        LocalTime: slot.LocalTime,
        Duration: slot.Duration,
        ReservationAttemptId: null
      }
    })
  }

  getRequestObjectSlots() {
    var bookingData = this.activityService.SessionBookingObj;

    return bookingData.Slots.map((slot, index) => {
      return {
        Time: slot.LocalTime,
        LockId: (this.lockResponse) ? this.lockResponse[slot.LocalTime]?.SlotLockIdDTO?.Id : null,
        Type: 4,
        DurationInMinutes: slot.Duration
      }
    })
  }
  isValidDuration() {
    var slotsSelected = Object.values(this.activityService.selectedOpenBookingSlots).filter(slot => slot);
    var durationSelected = slotsSelected.length * this.widgetData.TimeSlotUnitInMinutes;
    return durationSelected >= this.SelectedActivityData.MinDuration && durationSelected <= this.SelectedActivityData.MaxDuration
  }


  isNotPastTimeSlot(slotDateTime): boolean {
    const currentTime = Utilities.getRestaurantDateTime(this.activityService.restaurantWidgetSettings$.value.DaylightDelta);
    const past1hr = new Date(currentTime.valueOf());
    const slotTime = Utilities.parseDateString(slotDateTime);
    return slotTime >= past1hr;
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }


  checkFormValidity() {
    this.nextButton.disbaledproperity = !this.updateFormValidity();

  }

}
